import { topicDetailsActionTypes } from './Constants';

export function getTopicDetails(topicId, source, queries) {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_DETAILS,
		payload: {
			topicId,
			source,
			queries,
		},
	};
}

export function getTopicDetailsSuccess(topicDetails) {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_DETAILS_SUCCESS,
		payload: {
			topicDetails,
		},
	};
}

export function getTopicDetailsError() {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_DETAILS_ERROR,
		payload: {},
	};
}

export function getRelatedQuestions(data, topicId) {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS,
		payload: {
			data,
			topicId,
		},
	};
}

export function getRelatedQuestionsSuccess(data) {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getRelatedQuestionsError() {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_RELATED_QUESTIONS_ERROR,
		payload: {},
	};
}

export function getTopicExercise(data) {
	return {
		type: topicDetailsActionTypes.GET_TOPIC_EXERCISE,
		payload: data,
	};
}

export function cleanTopicDetailsState() {
	return {
		type: topicDetailsActionTypes.CLEAN_TOPIC_DETAILS_STATE,
	};
}
